module.exports = __webpack_public_path__ + "img/59.5c086aa6.jpg";